export const SERVER_URL = "https://staging.yogeshbot.com/api/v1"

export const TRANSACTION_TYPE_CREDIT = 'CREDIT';
export const TRANSACTION_TYPE_DEBIT = 'DEBIT';
